import React, { useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { CAR_DEAL } from '../../constants/columns';

// components
import EmptyData from '../../components/EmptyData/EmptyData';
import Loader from '../../components/Loader/Loader';

// icons
import icon from '../../brand/generated/header/newClient.svg';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../plugins/axios';
const columns = CAR_DEAL;

const ClientDeals = () => {
  const [deals, setDeals] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: 10,
  });
  const table = useTable(
    {
      columns,
      data: deals,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
    },
    usePagination
  );

  const init = async () => {
    setLoading(true);
    await axios
      .get('/api/crm/deals/getDeals', { params: { clientId: id, page: pagination?.page } })
      .then((res) => {
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
        setDeals(res.data.deals);
      })
      .catch((error) => {})
      .finally(() => setLoading(false));

  };
  React.useEffect(() => {
    init();
  }, [pagination.page]);

  const handleNavigate = (index) => {
    navigate(`/deals/deal/${deals.find((item) => item.id === index).id}/main-info`);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <EmptyData
          title={`Ð¡Ð´ÐµÐ»ÐºÐ¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ°`}
          subtitle={'Ð­ÑÐ¾Ñ ÐºÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ ÑÑÐ°ÑÑÐ²ÑÐµÑ Ð¿Ð¾ÐºÐ° Ð½Ð¸ Ð² Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ'}
          action={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²ÑÑ ÑÐ´ÐµÐ»ÐºÑ'}
          func={() => {
            navigate('/deals/create?userId=' + id);
          }}
          icon={icon}
          table={table}
          data={deals}
          navigate={handleNavigate}
          pagination
          setPagination={setPagination}
          p={pagination}
        />
      )}
    </>
  );
};

export default ClientDeals;
